import moment from "moment";

import { autoFillReturn } from "../../../helpers/autoFill";
import { MESA_ENTRADA_COMPROBANTES_ESTADOS, TIPO_COMPROBANTE, TIPO_EFECTORES } from "../../../utils/constants";

export const dataProformaForm = (proforma, tipoEfectorMenu, letra) => {
    const nroSucursal = autoFillReturn(`${proforma?.comprobante?.nroSucursal}`, 5);
    const nroFactura = autoFillReturn(`${proforma?.comprobante?.nroFactura}`, 8);

    return {
        idEfectorFacturacion: proforma?.comprobante?.comprobanteContrato?.idEfectorFacturacion,
        idTramite: proforma?.idTramite,
        idDestino: proforma?.idDestino,
        idEstado: MESA_ENTRADA_COMPROBANTES_ESTADOS.ENVIADA,
        fechaRecepcion: proforma?.fechaRecepcion,
        fechaCarga: moment().format(),
        observaciones: proforma?.observaciones ? proforma?.observaciones : "",
        idTipoComprobante: TIPO_COMPROBANTE.FACTURA,
        idProcedencia: proforma?.comprobante?.idProcedencia,
        idTipoFactura: letra,
        caiCae: "",
        internacion: false,
        ambulatoria: false,
        nroFactura: nroFactura,
        nroSucursal: nroSucursal,
        totalComprobante: proforma?.comprobante?.totalComprobante,
        fechaInicioVigencia: proforma?.comprobante?.fechaInicioVigencia,
        fechaFinVigencia: proforma?.comprobante?.fechaFinVigencia,
        proveedor: proforma?.comprobante?.comprobanteContrato?.proveedor,
        ...(tipoEfectorMenu  === TIPO_EFECTORES.INTEGRACION && 
            {
                nroAutorizacion: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.nroAutorizacion,
                periodoFacturado: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.periodoFacturado,
                recuperoSur: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.recuperoSur,
                codNom: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.codNom,
                cantidad: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.cantidad,
                valorUnitario: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.valorUnitario,
                cantidadModificada: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.cantidadModificada,
                debito: proforma?.comprobante?.comprobanteContrato?.comprobanteIntegracion?.debito
            }
        ),
        ...(tipoEfectorMenu  === TIPO_EFECTORES.PROVEEDOR && 
            { cuentasContables: proforma?.comprobante?.comprobanteContrato?.comprobanteCuentaContable }
        ),
    }
};

export const checkProformaValues = (formValues, proforma, tipoEfectorMenu) => {    
    if(
        formValues.idTramite !== proforma?.idTramite ||
        formValues.fechaRecepcion !== proforma?.fechaRecepcion ||
        formValues.idProcedencia !== proforma?.comprobante?.idProcedencia ||
        parseInt(formValues.nroFactura) !== proforma?.comprobante?.nroFactura ||
        parseInt(formValues.nroSucursal) !== proforma?.comprobante?.nroSucursal ||
        formValues.totalComprobante !== proforma?.comprobante?.totalComprobante ||
        formValues.fechaInicioVigencia !== proforma?.comprobante?.fechaInicioVigencia ||
        formValues.fechaFinVigencia !== proforma?.comprobante?.fechaFinVigencia 
    ){
        return false;
    }else{
        if(tipoEfectorMenu  === TIPO_EFECTORES.CONTRATO_PRESTADORES){
            return true;
        }else{
            if(
                formValues?.nroAutorizacion !== proforma?.comprobanteIntegracion?.nroAutorizacion ||
                formValues?.periodoFacturado !== proforma?.comprobanteIntegracion?.periodoFacturado ||
                formValues?.recuperoSur !== proforma?.comprobanteIntegracion?.recuperoSur ||
                formValues?.codNom !== proforma?.comprobanteIntegracion?.codNom ||
                formValues?.cantidad !== proforma?.comprobanteIntegracion?.cantidad ||
                formValues?.valorUnitario !== proforma?.comprobanteIntegracion?.valorUnitario
            ){
                return false;
            }else{
                return true
            }
        }

    }
}

export const checkValues = (formValues) => {
    if(
        formValues.idTramite === "" ||
        formValues.fechaRecepcion === "" ||
        formValues.idProcedencia === "" ||
        formValues.totalComprobante === "" ||
        formValues.fechaInicioVigencia === null ||
        formValues.fechaFinVigencia === null
    ){
        if(formValues.idTipoComprobante !== TIPO_COMPROBANTE.PROFORMA && (
            formValues.nroFactura === "" ||
            formValues.nroSucursal === ""
        )){
            return false;
        }else{
            return true;
        }
        
    }else{
        return true;
    }
}
